import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const SidebarButton = ({ btnObj }) => {
  const [isSubVisible, setSubVisibility] = useState(false);
  const location = useLocation();

  // Check if current page matches the button link
  const isActive = location.pathname.startsWith(btnObj.pageLink);

  return (
    <div className="flex flex-col mb-1">
      <Link 
        to={btnObj.testSub ? "#" : btnObj.pageLink}
        onClick={(e) => {
          if (btnObj.testSub) {
            e.preventDefault();
            setSubVisibility(!isSubVisible);
          }
        }}
        className={`flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-200 group ${
          isActive 
            ? "bg-zinc-900 text-white shadow-md dark:bg-zinc-100 dark:text-zinc-900" 
            : "text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-zinc-800/50 dark:hover:text-zinc-100"
        }`}
      >
        <div className="flex items-center gap-3">
          <div className={`${isActive ? "text-white dark:text-zinc-900" : "text-zinc-400 group-hover:text-zinc-600 dark:text-zinc-500 dark:group-hover:text-zinc-300"} transition-colors`}>
            {btnObj.icon}
          </div>
          <span className="font-medium text-sm tracking-wide">{btnObj.text}</span>
        </div>
        
        {btnObj.testSub && (
          <ChevronDown 
            className={`w-4 h-4 transition-transform duration-300 ${
              isSubVisible ? "rotate-180" : ""
            } ${isActive ? "text-white/70" : "text-zinc-400"}`} 
          />
        )}
      </Link>

      {/* Sub menu items */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isSubVisible ? "max-h-40 opacity-100 mt-1" : "max-h-0 opacity-0"
        }`}
      >
        {btnObj.testSub && btnObj.subButtons?.length > 0 && (
          <div className="pl-11 pr-4 py-2 space-y-1 border-l-2 border-zinc-200 ml-6 dark:border-zinc-800">
            {btnObj.subButtons.map((sub, i) => {
              const isSubActive = location.pathname === sub.link;
              return (
                <Link
                  key={i}
                  to={sub.link}
                  className={`block py-2 text-sm transition-colors duration-200 ${
                    isSubActive 
                      ? "text-zinc-900 font-semibold dark:text-white" 
                      : "text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-200"
                  }`}
                >
                  {sub.text}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SidebarButton;
